function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.81289 4.48438C5.81187 4.48438 5.81072 4.48438 5.80969 4.48438C5.45029 4.48438 5.11226 4.62448 4.857 4.87909C4.59894 5.13652 4.45679 5.47929 4.45679 5.84419V26.2344C4.45679 26.9821 5.06748 27.5919 5.81827 27.5938C8.98341 27.6014 14.2863 28.2611 17.9445 32.0893V10.7504C17.9445 10.497 17.8798 10.2589 17.7576 10.0618C14.7551 5.22646 8.9852 4.4918 5.81289 4.48438Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M33.5435 26.2345V5.84419C33.5435 5.47929 33.4014 5.13652 33.1433 4.87909C32.8881 4.62448 32.5498 4.48438 32.1907 4.48438C32.1896 4.48438 32.1884 4.48438 32.1874 4.48438C29.0152 4.49192 23.2454 5.22659 20.2427 10.0619C20.1205 10.259 20.0559 10.4971 20.0559 10.7506V32.0894C23.7142 28.2611 29.017 27.6014 32.1822 27.5938C32.9328 27.5919 33.5435 26.9821 33.5435 26.2345Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M36.6403 9.18701H35.6544V26.2347C35.6544 28.1438 34.0989 29.7006 32.1869 29.7053C29.5022 29.7117 25.0755 30.2367 21.9404 33.2039C27.3625 31.8763 33.0784 32.7393 36.3359 33.4816C36.7427 33.5743 37.163 33.4786 37.4889 33.2188C37.8136 32.9597 37.9999 32.5724 37.9999 32.1567V10.5466C38 9.79693 37.39 9.18701 36.6403 9.18701Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M2.34552 26.2347V9.18701H1.35956C0.610049 9.18701 0 9.79693 0 10.5466V32.1564C0 32.5722 0.18629 32.9594 0.511019 33.2184C0.836643 33.4781 1.25656 33.5741 1.66394 33.4812C4.92146 32.7388 10.6375 31.8759 16.0593 33.2035C12.9244 30.2364 8.4977 29.7116 5.813 29.7052C3.90109 29.7006 2.34552 28.1438 2.34552 26.2347Z",
  fill: "white"
});

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.59ee9f6e.svg";
export { ForwardRef as ReactComponent };